const state = {
 active: false,
 description: "",
 type: "error",
};

const mutations = {
 setMessage(state, messageParams) {
  state.active = true;
  state.description = messageParams.data.description;
  state.type = messageParams.data.type;
 },
 disableMessage(state) {
  state.active = false;
  state.description = "";
  state.type = "error";
 },
};

const actions = {
 setMessage(context, messageParams) {
  context.commit("setMessage", {
   data: messageParams,
  });
  setTimeout(function() {
   context.commit("disableMessage");
  }, 3000);
 },
};

const getters = {
 getMessage(state) {
  return state;
 },
};

export default {
 namespaced: false,
 state,
 mutations,
 actions,
 getters,
};
